var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-chevron-down.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.13802 9.80469L8.00002 6.94269L10.862 9.80469L11.8047 8.86202L8.00002 5.05735L4.19535 8.86202L5.13802 9.80469Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop_icon.5c798b2e1fe82fa05334710b640dcce5.svg";
export { ForwardRef as ReactComponent };